
import { sendPost } from '../http.js'
const api = {
	'orderReward': '/user/order/reward'
}
const requestFunObj = {}
for (const key in api) {
    requestFunObj[key]  = (params) => {
        return sendPost(api[key], params)
    }
}
export default requestFunObj
